module.exports = __webpack_public_path__ + "img/右对齐2.962fbd39.svg";